import axios from '@/plugins/axios'
import _ from 'lodash'
import Join from './join'

export default class ReportService {
  report = {}
  options = {
    drag: false,
    formTargetId: '',
    processTargetId: '',
    tables: [],
    dataSourceReports: [],
    leftPanel: {type: '', id: ''},
    form: [],
    process: [],
    reportTables: [],
    // 全部主子表的归档列
    allAchivedColumns: []
  }

  // 增加关联
  addJoins (joins) {
    // removedJoins - 被移除的关联表
    // let removedJoins = _.differenceBy(this.report.joins, joins, 'id')

    this.report.joins = []
    // 删除没有被引用的数据列
    // this.report.columns = this.report.columns.filter(m => !removedJoins.some(n => m.expressionText.includes(n.id)))
    // 删除关联表默认排序,分组统计,系统默认筛选中的引用
    // this.report.orderBies = this.report.orderBies.filter(m => this.report.columns.some(n => n.id === m.columnId))
    // this.report.groupBies = this.report.groupBies.filter(m => this.report.columns.some(n => n.id === m.columnId))
    // // 如果是高级筛选且表达式中包含引用列,则直接清除该高级筛选
    // if (this.report.systemFilterSwitch && removedJoins.some(m => this.report.filterExpression.includes(m.referenceColumnId))) {
    //   this.report.filterExpression = ''
    // } else {
    //   // 普通筛选则要清除对应筛选条件和修改筛选表达式,现在是直接清空默认筛选
    //   this.report.filters = this.report.filters.filter(m => m.filterType !== 'senior')
    //   this.report.filterExpression = ''
    // }
    // 增加关联关系
    joins.forEach((el) => {
      this.report.createOrUpdate(new Join(el))
    })
  }

  // 初始化报表列
  initReportColumn (tableId) {
    this.report.mainTableId = tableId
  }

  delete (object) {
    this.report.delete(object)
  }

  createOrUpdate (object) {
    // 插入列/按钮/条件/排序
    this.report.createOrUpdate(object)
  }

  moveColumn (index, type) {
    let length = this.report.columns.length
    if (type === 'left') {
      // 左移
      if (index > 0) {
        this.report.columns[index - 1] = this.report.columns.splice(index, 1, this.report.columns[index - 1])[0]
      }
    } else {
      // 右移
      if (index < length && index !== (length - 1)) {
        this.report.columns[index] = this.report.columns.splice(index + 1, 1, this.report.columns[index])[0]
      }
    }
  }

  getReportJoinTables () {
    let dataTables = []
    this.report.joins.forEach(m => {
      if (m.joinType && m.joinType !== 'archived') {
        let dataSourcereport = _.cloneDeep(this.options.dataSourceReports.find(n => n.id === m.referenceTableId))
        dataSourcereport.joinType = 'dataSourceReport'
        dataSourcereport.type = m.type
        dataSourcereport.relationId = m.id
        if (dataSourcereport) {
          dataSourcereport.name = m.name ? m.name : dataSourcereport.name
          if (dataSourcereport.columns) {
            dataSourcereport.columns.forEach(el => {
              el.relationId = dataSourcereport.relationId
            })
          }
          dataTables.push(dataSourcereport)
        }
      } else {
        let table = _.cloneDeep(this.options.tables.find(n => n.id === m.referenceTableId))
        if (table) {
          table.joinType = 'archived'
          table.type = m.type
          table.relationId = m.id
          table.name = m.name ? m.name : table.name
          if (table.columns) {
            table.columns.forEach(el => {
              el.relationId = table.relationId
            })
          }
          dataTables.push(table)
        }
      }
    })
    let mainTable = _.cloneDeep(this.options.tables.find(m => m.id === this.report.mainTableId))
    if (mainTable) {
      mainTable.relationId = mainTable.id
      dataTables.unshift(mainTable)
    }
    return dataTables
  }

  checkUserds (columns) {
    let arrColumn = []
    if (typeof (columns) === 'object') {
      arrColumn.push(columns)
    } else {
      arrColumn = columns
    }
    let arr = []
    arrColumn.forEach(column => {
      if (this.report.checkUsed(column.id)) {
        arr.push(this.report.checkUsed(column.id))
      }
    })
    return arr
  }

  reset () {
    // 清空报表信息
    this.report.resetReport()
  }

  saveSortOfColumns (columns) {
    // 列字段排序保存
    let delColumns = _.differenceBy(this.report.columns, columns, 'id')
    delColumns.forEach(m => {
      this.report.delete(m)
    })
    this.report.columns = columns
  }

  dragFilter (flag) {
    this.options.drag = flag
  }

  openPanel (id, type) {
    if (this.report.mainTableId !== '') {
      // 选择完主表之后才能允许弹出面板
      this.options.leftPanel.id = id
      this.options.leftPanel.type = type
    }
  }

  closePanel () {
    this.options.leftPanel.type = ''
    this.options.leftPanel.id = ''
  }

  updateExportColumn (exportColumn) {
    this.report.columns.forEach(m => {
      if (!exportColumn.includes(m.id)) {
        m.exportable = false
      } else {
        m.exportable = true
      }
    })
  }

  loadForm () {
    axios.get('/form-api/defines')
      .then(res => {
        this.options.form = res.data
      })
  }

  loadProcesse () {
    axios.get('/process-api/processes/findAll')
      .then(res => {
        this.options.process = res.data
      })
  }
  // 加载当前归档表的指向
  loadTarget (tableId) {
    this.loadTargetForm(tableId)
    this.loadTargetProcess(tableId)
  }
  loadTargetForm (tableId) {
    return axios.get(`/form-api/defines/findIdByTable?tableId=${tableId}`)
      .then(res => {
        this.options.formTargetId = res.data
      })
  }
  loadTargetProcess (tableId) {
    return axios.get(`/process-api/processes/findIdByTable?tableId=${tableId}`)
      .then(data => {
        this.options.processTargetId = data.data
      })
  }
  // 加载当前归档表的指向
  loadTargetPromise (tableId) {
    return Promise.all([this.loadTargetForm(tableId), this.loadTargetProcess(tableId)])
  }

  findTables (tableId) {
    if (this.options.tables) {
      return this.options.tables.find(m => m.id === tableId)
    }
  }

  loadReportColumn () {
    axios.get('/report-api/report/definition/reports')
      .then(res => {
        this.options.reportTables = res.data
      })
  }

  loadDataReport (reportId) {
    return new Promise((resolve, reject) => {
      let dataSourceReport = this.options.dataSourceReports.find(m => m.id === reportId)
      if (!dataSourceReport.columns || !dataSourceReport.columns.length) {
        axios.get(`/report-api/report/definition/${reportId}?type=run`)
          .then(res => {
            let data = res.data
            let index = this.options.dataSourceReports.findIndex(n => n.id === data.id)
            if (index === 0 || index) {
              this.options.dataSourceReports[index] = data
            } else {
              this.options.dataSourceReports.push(data)
            }
            resolve()
          })
      } else {
        resolve()
      }
    })
  }

  build (isUseDatasource, selectTable) {
    let cloneReport = _.cloneDeep(this.report)
    // 设计页的15就没用了呀。
    // 如果没有子报表，并且分页小于20，则手动调整为20
    // 需要区分辅助表
    if (!cloneReport.dataSourceReport && cloneReport.children.length === 0 && cloneReport.pageNumber < 20) {
      cloneReport.pageNumber = 20
    }
    if (cloneReport.appSwitch) {
      cloneReport.appModel.appIcon = cloneReport.appModel.appIcon.includes('data:image') ? '' : cloneReport.appModel.appIcon
    }
    cloneReport.mergeSame = JSON.stringify(cloneReport.mergeSame)
    cloneReport.editColumns = JSON.stringify(cloneReport.editColumns)
    cloneReport.filters.forEach(filter => {
      filter.position = JSON.stringify(filter.position)
      filter.dataSource = JSON.stringify(filter.dataSource)
      filter.template = JSON.stringify(filter.template)
    })

    cloneReport.columns.forEach((el, index) => {
      // 排序字段有一些奇怪的问题, 在提交的时候, 按照字段重新排序
      el.sort = index + 1
      el.format.colorFormats = JSON.stringify(el.format.colorFormats)
      el.format.displayFormats = JSON.stringify(el.format.displayFormats)
      el.format.dataFormat = JSON.stringify(el.format.dataFormat)
    })
    // 对按钮中的某些字段转json存储
    cloneReport.buttons.forEach(button => {
      if (typeof button.setting === 'object') {
        button.setting = JSON.stringify(button.setting)
      }
      if (typeof button.filterItems === 'object') {
        button.filterItems = JSON.stringify(button.filterItems)
      }
    })

    cloneReport.handleSenior(isUseDatasource, selectTable)

    return cloneReport
  }

  // 发布
  publish () {
    if (this.report.mainTableId !== '') {
      let data = this.build()
      return axios.post(`/report-api/report/definition`, data)
    }
  }

  // 给控件名字新增 拼音 和 缩写
  async getPinyinByHanzi (name) {
    let result = {}
    await axios({
      method: 'get',
      url: '/shared-api/pinyin/getPinyinByHanzi',
      disableInterceptors: true,
      params: {hanzi: name}
    }).then(res => {
      result = res.data
    }).catch(res => {
      result = {pinyinName: '', pinyinFirstChar: ''}
    })
    return result
  }
  // 获取表单所有的 控件
  getAllComponent (components, result = []) {
    for (let i = 0; i < components.length; i++) {
      components[i] && result.push(components[i])
      components[i].children && components[i].children.length > 0 && this.getAllComponent(components[i].children, result)
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/store/report/reportService.js